module.exports = __webpack_public_path__ + "static/img/3.ee07bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/ltsj/3.png
// module id = QX0c
// module chunks = 1